import { render } from "./ForumForm.vue?vue&type=template&id=3864d0cc&scoped=true"
import script from "./ForumForm.vue?vue&type=script&lang=js"
export * from "./ForumForm.vue?vue&type=script&lang=js"

import "./ForumForm.vue?vue&type=style&index=0&id=3864d0cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3864d0cc"]])

export default __exports__